module.exports = __webpack_public_path__ + "static/media/Venomancer.e56d483d.png";